import { reqApiVersion } from './req-features/req-api-version';
import { resApiVersion } from './res-features/res-api-version';
export const apiVersion = (options) => [reqApiVersion(options), resApiVersion(options)];
